import { render, staticRenderFns } from "./DashboCertiPruebas.vue?vue&type=template&id=6a88faff"
import script from "./DashboCertiPruebas.js?vue&type=script&lang=js&external"
export * from "./DashboCertiPruebas.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports